module.exports = __webpack_public_path__ + "img/employee-data-basic.a5df7fca.svg";